import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { BildungsangeboteService } from 'projects/suche-lib/src/lib/services/bildungsangebote.service';
import { OPEN_GRAPH_SERVICE } from 'projects/suche-lib/src/lib/services/open-graph.service';
import { CommonStateService } from 'projects/suche-lib/src/lib/services/state/common-state.service';
import { BildungsangebotTerminDetail } from 'projects/suche-lib/src/projects';
import { catchError, EMPTY, tap } from 'rxjs';
import { UrlService } from '../../../../suche-lib/src/lib/services/state/url.service';

export const detailseiteResolver: ResolveFn<BildungsangebotTerminDetail> = (
  route: ActivatedRouteSnapshot
) => {
  const opengrapService = inject(OPEN_GRAPH_SERVICE);
  const commonstateService = inject(CommonStateService);
  const urlService = inject(UrlService);
  return inject(BildungsangeboteService)
    .getAktuellenTermin$(String(route.paramMap.get('id')))
    .pipe(
      tap((termin) => {
        opengrapService.setDescription(
          `Informieren Sie sich zum Weiterbildungsangebot ${termin.angebot.titel}. Das Wichtigste zu Lerninhalten & Weiterbildungsanbieter in Kürze.`
        );
        commonstateService.setSelectedTermin(termin);
      }),
      catchError((error) => {
        if (error.cause.status === 404) {
          urlService.updateUrl(null, 'angebot-nicht-gefunden');
        } else {
          urlService.updateUrl(null, 'error');
        }
        return EMPTY;
      })
    );
};
